<template>
  <div class="flex flex-col items-center my-5">
    <circle-icon />
    <h3
      class="text-semibold text-fg-default text-lg lg:text-2xl text-center mt-5"
    >
      Confirming Deposit
    </h3>
    <p class="text-primary text-4xl font-normal my-3">
      {{ `${dispMinutes}:${dispSeconds}` }}
    </p>
    <p
      style="word-break: normal"
      class="text-xs lg:text-sm font-normal mt-2 px-4 lg:px-0 lg:w-2/4 mx-auto text-center text-fg-muted"
    >
      This modal will close once deposit is confirmed
    </p>
  </div>
</template>

<script>
import getPendingDeposits from '@/mixins/pendingDeposit.js'
import country from '@/mixins/getCountryDetails.js'
export default {
  mixins: [getPendingDeposits, country],
  components: {
    CircleIcon: () => import('@/assets/icons/CircleIcon.vue')
  },
  data () {
    return {
      minutes: 0,
      seconds: 59,
      detailsInterval: '',
      timerInterval: ''
    }
  },
  computed: {
    dispMinutes () {
      return this.minutes
    },
    dispSeconds () {
      return this.seconds
    },
    pendingAssetDeposits () {
      return this.$store.state.transactions.deposits.items
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    depositedAmountDetails () {
      const depositDetails = this.pendingAssetDeposits.find(
        (deposit) => deposit.amount.currency === this.country.currency
      )
      return depositDetails
    }
  },
  methods: {
    countDown () {
      this.timerInterval = setInterval(() => {
        this.seconds--
        if (this.seconds < 1) {
          clearInterval(this.timerInterval)
          this.$store.dispatch(
            'terminal/setFailedDepositAssetReason',
            'timeout'
          )
          this.$emit('setView', 'deposit-asset-failed')
        }
      }, 1000)
    }
  },
  async mounted () {
    const payload = {
      page: 1,
      size: 10,
      status: this.$STATUS.PENDING,
      type: 'asset_deposit',
      from: '',
      to: ''
    }
    await this.getDeposits(payload)
    this.detailsInterval = setInterval(async () => {
      await this.getDeposits(payload)
      if (this.pendingAssetDeposits.length > 0) {
        if (
          this.depositedAmountDetails.amount.amount ===
          this.transferDetails.debitAmount
        ) {
          this.$store.dispatch(
            'terminal/setAssetDepositId',
            this.depositedAmountDetails.id
          )
          this.$emit('setView', 'deposit-confirmed')
        } else {
          this.$store.dispatch(
            'terminal/setFailedDepositAssetReason',
            'amount-mismatch'
          )
          this.$emit('setView', 'deposit-asset-failed')
        }
      }
    }, 10000)
    this.countDown()
  },
  beforeDestroy () {
    clearInterval(this.detailsInterval)
    clearInterval(this.timerInterval)
  }
}
</script>
